import { useState } from 'react'
import { isEmpty } from 'ramda'

const useLightbox = (images, enableClickPropagation = true) => {
  const loopImage = i => i % images.length
  const prevImage = i => loopImage(i + images.length - 1)
  const nextImage = i => loopImage(i + 1)

  const [lightbox, setLightbox] = useState({ isOpen: false, currentImage: 0 })
  const [mouseDown, setMouseDown] = useState({})

  const openImage = index => e => {
    if (!enableClickPropagation) e.stopPropagation()
    // This ensures that if the mouse moves between `onMouseDown`
    // being called and `onClick` , we don't open the lightbox.
    // Useful for the image slider where we don't want to open
    // unless the mouse stays still.
    if (
      !isEmpty(mouseDown) &&
      (Math.floor(mouseDown.clientX) !== Math.floor(e.clientX) ||
        Math.floor(mouseDown.clientY) !== Math.floor(e.clientY))
    ) {
      e.preventDefault()
      return
    }
    setLightbox({ isOpen: true, currentImage: index })
  }

  const reset = e => {
    setMouseDown({})
    e.preventDefault()
  }

  const close = () => {
    setLightbox({ isOpen: false, currentImage: lightbox.currentImage })
  }

  const onMouseDown = e => {
    setMouseDown({
      clientX: e.clientX,
      clientY: e.clientY
    })
    e.preventDefault()
  }

  const { isOpen, currentImage } = lightbox
  const setImage = index =>
    setLightbox({
      isOpen: true,
      currentImage: index
    })

  const props = {
    isOpen,
    mainSrc: images[currentImage],
    prevSrc: images[prevImage(currentImage)],
    nextSrc: images[nextImage(currentImage)],
    onCloseRequest: close,
    onMovePrevRequest: () => setImage(prevImage(currentImage)),
    onMoveNextRequest: () => setImage(nextImage(currentImage))
  }
  return { props, openImage, close, isOpen, currentImage, onMouseDown, reset }
}

export default useLightbox
